module.exports = __webpack_public_path__ + "img/54.3.TP.f23abe47.png";